<template>
  <!--  -->
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form
      ref="form"
      inline
      :model="searchData"
      label-width=""
    >
      <el-form-item label="账号">
        <el-input
          style="width: 200px"
          clearable
          v-model="searchData.account"
          size="mini"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="getList"
        >搜索</el-button>
        <el-button
          type="info"
          size="mini"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <el-button
      style="margin-bottom: 10px"
      icon="el-icon-plus"
      type="primary"
      size="mini"
      plain
      @click="handleAdd(null)"
    >新增
    </el-button>
    <!-- list -->
    <el-table
      :data="userList"
    >
      <el-table-column
        prop="account"
        label="账号"
        width="260"
      ></el-table-column>
      <el-table-column
        prop="username"
        label="姓名"
        width="260"
      ></el-table-column>
<!--      <el-table-column-->
<!--          prop="wechat_account"-->
<!--          label="微信号"-->
<!--          width="260"-->
<!--      ></el-table-column>-->
      <el-table-column
        prop="phone"
        label="手机号码"
        width="200"
      ></el-table-column>
<!--      <el-table-column-->
<!--        prop="level_dsc"-->
<!--        label="级别"-->
<!--        width="200"-->
<!--      ></el-table-column>-->
<!--      <el-table-column-->
<!--        prop="roles"-->
<!--        label="角色[部门]"-->
<!--        width="200"-->
<!--      >-->
<!--        <template slot-scope="scope">-->
<!--          <el-tag v-for="rolename in scope.row.role_names">{{rolename}}</el-tag>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          >修改
          </el-button>
<!--          <el-button-->
<!--            size="mini"-->
<!--            type="text"-->
<!--            icon="el-icon-plus"-->
<!--            @click="handleAdd(scope.row)"-->
<!--          >新增-->
<!--          </el-button>-->
          <el-button
            v-if="scope.row.id != 1"
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDel(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增编辑 -->
    <el-dialog
      :title="formData.id ? '编辑' : '新增'"
      :visible.sync="show_update"
      width="width"
    >
      <el-form
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item
          label="姓名"
          prop="username"
          :rules="rules"
        >
          <el-input
            style="width: 250px"
            v-model="formData.username"
            clearable
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

<!--        <el-form-item-->
<!--            label="微信号"-->
<!--            prop="wechat_account"-->
<!--            :rules="rules"-->
<!--        >-->
<!--          <el-input-->
<!--              style="width: 250px"-->
<!--              v-model="formData.wechat_account"-->
<!--              clearable-->
<!--              size="small"-->
<!--              placeholder="请输入"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->
        <el-form-item
          label="账号"
          prop="account"
          :rules="rules"
        >
          <el-input
            style="width: 250px"
            v-model="formData.account"
            clearable
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          prop="password"
          :rules="rules"
          v-if="!formData.id"
        >
          <el-input
            style="width: 250px"
            v-model="formData.password"
            type="password"
            clearable
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          prop="password"
          v-if="formData.id"
        >
          <el-input
            style="width: 250px"
            v-model="formData.password"
            type="password"
            clearable
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="phone"
          :rules="rules"
        >
          <el-input
            style="width: 250px"
            v-model="formData.phone"
            clearable
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
<!--        <el-form-item-->
<!--          label="角色"-->
<!--          prop="role_ids"-->
<!--          :rules="rules"-->
<!--        >-->
<!--          <SelectRole-->
<!--            style="width: 250px"-->
<!--            v-model="formData.role_ids"-->
<!--          ></SelectRole>-->
<!--        </el-form-item>-->

        <el-form-item
          label="状态"
          prop="status"
          :rules="rules"
        >
          <el-radio-group v-model="formData.status">
            <el-radio :label="10">禁用</el-radio>
            <el-radio :label="20">启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          @click="show_update = false"
          size="small"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getListAPI, getDetailAPI, addAPI, editAPI, delAPI } from './api'
import { authBtnMixin } from '@/mixins/authBtnMixin'
import SelectRole from '@/views/powerManage/role/select-role-list.vue'
import SelectAdminUser from "@/components/select-admin-user/index.vue"

export default {
  name: 'Index',
  mixins: [authBtnMixin],
  // components: { SelectRole, SelectAdminUser },
  data () {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      show_update: false,
      list: [],
      userList: [],
      searchData: {
        account: '',
        wechat_account: '',
      },
      formData: {
        account: '',
        wechat_account: '',
        username: '',
        password: '',
        status: 20,
        phone: '',
        email: '',
        // pid_arr: [],
        // brand_ids: [],
        // role_ids: [],
        user_type: 1
      },
      total: 0,
      detail: {}
    }
  },

  watch: {},
  activated () {
  },
  mounted () {
    this.getList()
  },

  methods: {
    handleAdd (parent) {
      this.formData = {
        account: '',
        username: '',
        wechat_account: '',
        password: '',
        status: 20,
        phone: '',
        email: '',
        pid_arr: [],
        brand_ids: [],
        role_ids: [],
        user_type: 1
      }
      if (parent) {
        let parent_pid_arr = parent.pid_arr ?? []
        parent_pid_arr.push(parent.id)
        this.formData.pid_arr = parent_pid_arr
      }

      this.show_update = true
    },

    handleUpdate (row) {
      this.formData = row
      this.show_update = true
    },
    async getList () {
      const res = await getListAPI(this.searchData)
      this.userList = res.data
      this.total = res.total
    },
    // 新增
    goAdd () {
      this.formData = {
        username: '',
        password: '',
        status: 20,
        phone: '',
        email: '',
        brand_ids: [],
        role_ids: [],
        user_type: 1
      }
      this.show_update = true
      this.$refs.form.resetFields()
    },
    // 编辑
    async handleEdit ({ id }) {
      const res = await getDetailAPI(id)
      this.formData = res
      this.show_update = true
      this.$refs.form.resetFields()
    },
    // 删除
    handleDel ({ id }) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delAPI(id).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.show_update = false
              this.getList()
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('添加成功')
              this.show_update = false
              this.getList()
            })
          }
        }
      })
    },
    reset () {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  .inviter {
    display: inline-flex;
    align-items: center;
    background: #f8f8f9;
    border-radius: 5px;
    padding: 0 20px;

    .inviter-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .inviter-name {
        font-weight: 600;
      }
    }
  }

  .balance-box {
    display: flex;
    // align-items: center;
    .balance-item {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      background: #f5f5f5;
      border-radius: 5px;
      padding: 0 20px;
      margin-right: 20px;

      span {
        &:last-child {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
